import type { ILoggingClient } from "../types.ts";

const client: ILoggingClient = {
  warning: (message) => {
    console.warn("[logging] %O", message);
  },
  error: (error) => {
    console.error("[logging] %O", error);
  },
};

export const init = () => client;
